import React from 'react';


import Styles from './index.module.less';

import { isCubeApp, commandMessage } from '@helpers/Constants';
import NativeInterface from '@helpers/NativeInterface';

import HalfScreenInfoModal from '@components/HalfScreenInfoModal';
import CommonBtn from '@components/CommonBtn';

import Http from '@helpers/Http';
import { Api } from '@apis/client';

interface IProps {
  deviceInfo: any;
  onClose: () => void;
  onConfirm: () => void;
}

const contentDesc = [
  {
    desc: '1. 为向您提供实时查看孩子的精准位置信息、行踪轨迹信息的服务，我们需要获取您授权提供的您孩子的位置信息（包括动态位置信息、精准定位信息、行踪轨迹信息）以及运动信息（包括步数、步频、运动距离、运动时间、运动速度）。'
  },
  {
    desc: '2. 如您拒绝提供授权，仅会使您无法正常使用希沃学生证设备的定位服务，但不影响希沃魔方及希沃学生证设备的其他功能正常使用。'
  },
  {
    desc: '3. 您可随时通过【定位-定位设置】自主选择开启或关闭定位服务。'
  },
]

const LocationPopWindow = (props: IProps) => {
  const { deviceInfo } = props;

  const toAuthUrl1 = async () => {
    const url = 'https://account.seewo.com/seewo-account/agreement?appCode=seewo-yunban-mobile&type=1&index=4';
    if(isCubeApp()) { //在app环境中 跳转到外部小页面时需要打开新的webview容器
      NativeInterface.postMessage(commandMessage.openNewContainer, { url });
    } else {
      window.location.assign(url);
    }
  }

  const toAuthUrl2 = async () => {
    const url = 'https://account.seewo.com/seewo-account/agreement?appCode=seewo-yunban-mobile&type=1&index=3';
    if(isCubeApp()) { //在app环境中 跳转到外部小页面时需要打开新的webview容器
      NativeInterface.postMessage(commandMessage.openNewContainer, { url });
    } else {
      window.location.assign(url);
    }
  }

  const enableLocationSwitch = () => {
    Http.post(Api.PostDeviceSwitchStatus,
      { snCode: deviceInfo.snCode, company: deviceInfo.company, key: 'locationSwitch', value: '1' }
    )
    props.onConfirm && props.onConfirm();
  }

  const disableLocationSwitch = () => {
    Http.post(Api.PostDeviceSwitchStatus,
      { snCode: deviceInfo.snCode, company: deviceInfo.company, key: 'locationSwitch', value: '0' }
    )
    props.onClose && props.onClose();
  }

  return (
    <HalfScreenInfoModal
      title="温馨提示"
      height="9rem"
      onClose={ props.onClose }
      hideCloseBtn={ true }
      headerStyleName={ Styles.header }
    >
      <div styleName='subTitle'>{'欢迎使用希沃电子学生证定位服务'}</div>
      <div styleName="content" style={{ maxHeight: '60%'}}>
        {
          contentDesc.map((item) => {
            return (
              <div styleName="desc">{ item.desc }</div>
            )
          })
        }
        <div styleName="tip">
          { '请仔细阅读'}
          <span onClick={ toAuthUrl1 }>{ '《授权使用声明》' }</span>
          { '，并确认是否同意'}
          <span onClick={ toAuthUrl2 }>{ '《个人信息使用授权同意书》' }</span>
          { '的内容。'}
        </div>
      </div>
      <div styleName='buttonLayout'>
        <CommonBtn
          type="auto"
          btnText="暂不同意"
          onConfirm={ disableLocationSwitch }
          style={{ width: '2.54rem', background: '#F2F4F7', color: '#505359', fontSize: '.32rem' }}
        />
        <CommonBtn
          type="auto"
          btnText="同意"
          onConfirm={ enableLocationSwitch }
          style={{ width: '3.76rem', background: '#256FFF', color: '#FFFFFF', fontSize: '.32rem' }}
        />
      </div>
    </HalfScreenInfoModal>
  )
}

export default LocationPopWindow;